var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { util } from '@joint/plus';
import { RectPrism, RectPrismView } from './rect-prism';
var TYPE = 'yamazumi.TaskElement';
var TaskElement = /** @class */ (function (_super) {
    __extends(TaskElement, _super);
    function TaskElement(attributes, options) {
        var _this = _super.call(this, attributes, options) || this;
        _this.setTaskHeight();
        _this.on('change:duration', function () {
            _this.setTaskHeight();
        });
        return _this;
    }
    TaskElement.prototype.defaults = function () {
        return util.defaultsDeep({
            type: TYPE,
            attrs: {
                root: {
                    cursor: 'move'
                }
            }
        }, _super.prototype.defaults.call(this));
    };
    TaskElement.prototype.setTaskHeight = function () {
        var height = this.get('duration') * this.get('durationHeight');
        this.prop('size/height', height);
    };
    return TaskElement;
}(RectPrism));
export { TaskElement };
var TaskElementView = /** @class */ (function (_super) {
    __extends(TaskElementView, _super);
    function TaskElementView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.animation = {
            easing: 'ease-in',
            fill: 'forwards',
            duration: 200
        };
        return _this;
    }
    TaskElementView.prototype.updateTransformation = function () {
        var _a = this, el = _a.el, model = _a.model;
        var _b = model.get('position'), x = _b.x, y = _b.y;
        var transform = "translate(".concat(x, "px, ").concat(y, "px)");
        var keyframes = { transform: [transform] };
        var move;
        if (this.move) {
            move = this.move;
            move.effect.setKeyframes(keyframes);
            move.currentTime = 0;
        }
        else {
            move = el.animate(keyframes, this.animation);
            move.onfinish = function () { return move.commitStyles(); };
            this.move = move;
        }
        if (model.get('animation')) {
            move.play();
        }
        else {
            move.finish();
        }
    };
    return TaskElementView;
}(RectPrismView));
export { TaskElementView };
